<ng-template #boxContainer></ng-template>

<div [innerHTML]="errorMessage" [hidden]="!errorMessage || isInLoadMode || isInEditMode" class="alert alert-danger box-error-container" role="alert">
</div>
